import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { APP_ROUTES } from "../../constants";
import { CashDepositLandingPage } from "../CashDepositLandingPage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <CashDepositLandingPage />
      <SupportSheet
        namespace="cash-deposit"
        visible
        onClose={() => navigate(APP_ROUTES.CASH_DEPOSIT_LANDING_PAGE)}
      />
    </>
  );
});
